/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.5.3(793ede49d53dba79d39e52205f16321278f5183c)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.es", {
	"vs/base/common/errors": [
		"{0}. Código de error: {1}",
		"Permiso denegado (HTTP {0})",
		"Permiso denegado",
		"{0} (HTTP {1}: {2})",
		"{0} (HTTP {1})",
		"Error de conexión desconocido ({0})",
		"Error de conexión desconocido. Es posible que ya no esté conectado a Internet o que el servidor al que se había conectado esté sin conexión.",
		"{0}:{1}",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
		"Se produjo un error del sistema ({0})",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
		"{0} ({1} errores en total)",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
		"Sin implementar",
		"Argumento no válido: {0}",
		"Argumento no válido",
		"Estado no válido: {0}",
		"Estado no válido",
		"No se pudo cargar un archivo necesario. O bien no está conectado a Internet o el servidor al que se había conectado está sin conexión. Actualice el explorador y vuelva a intentarlo.",
		"No se pudo cargar un archivo requerido. Reinicie la aplicación para intentarlo de nuevo. Detalles: {0}",
	],
	"vs/base/common/keyCodes": [
		"Windows",
		"Control",
		"Mayús",
		"Alt",
		"Cmd",
		"Windows",
		"Ctrl",
		"Mayús",
		"Alt",
		"Cmd",
		"Windows",
	],
	"vs/base/common/severity": [
		"Error",
		"Advertencia",
		"Información",
	]
});